import axios from "axios";
import moment from 'moment';
import qs from 'qs'
export default {
    namespaced: true,
    state: {
        loading: false,
        contractDetails: {},
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setContractDetails(state, data) {
            state.contractDetails = data;
        }
    },
    actions: {
        getContract({ commit }, contractType) {
            return axios
                .get(`/api/contract/get-contract-content?ContractType=${contractType}`)
                .then((response) => {
                    commit("setContractDetails", response.data.payload);
                    return response.data.payload;
                }).catch(err => {
                    throw false;
                });
        },
    },
    getters: {
        loading: (state) => state.loading,
        contractDetails: (state) => state.contractDetails
    },
};
